module.exports = __webpack_public_path__ + "static/img/A.8de86ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/A.png
// module id = Y37l
// module chunks = 0